import * as THREE from 'three'

import styled, { injectGlobal } from 'styled-components'

import BackgroundShader from '../shader/background'
import React from 'react'

injectGlobal`
  html, body {
    background: #222;
    width: 100%;
    height: 100%;
    margin: 0;
    padding: 0;
  }
`

const Canvas = styled.canvas`
  display: block;
`

export default class extends React.PureComponent {
  componentDidMount () {
    this.scene = new THREE.Scene()
    this.camera = new THREE.OrthographicCamera(-1, 1, 1, -1, 0, 1)

    this.renderer = new THREE.WebGLRenderer({ canvas: this.canvasRef })
    this.renderer.setSize(window.innerWidth, window.innerHeight)
    this.renderer.setPixelRatio(window.devicePixelRatio)

    this.uniforms = {
      time: { value: 1.0 }
    }

    const geometry = new THREE.PlaneBufferGeometry(2, 2)
    const material = new THREE.ShaderMaterial({
      uniforms: this.uniforms,
      vertexShader: BackgroundShader.vertex,
      fragmentShader: BackgroundShader.fragment
    })

    this.scene.add(new THREE.Mesh(geometry, material))
    this.animate()

    window.addEventListener('resize', this.resizeHandler = ::this.onWindowResize, false)
  }

  componentWillUnmount () {
    window.removeEventListener('resize', this.resizeHandler)
  }

  onWindowResize () {
    this.renderer.setSize(window.innerWidth, window.innerHeight)
  }

  animate (timestamp) {
    requestAnimationFrame(::this.animate)

    this.uniforms.time.value = timestamp / 1000

    this.renderer.render(this.scene, this.camera)
  }

  render () {
    return (
      <Canvas innerRef={ref => this.canvasRef = ref} />
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/App.js